<div class="header">
  <div class="section fill">
    @if (isStaffApp$ | async) {
      <h3>
        Chatting with
        {{
          (
            (activeThread$ | async)?.thread?.customerProfile ||
            (activeThread$ | async)?.thread?.orderCard?.order?.customerProfile
          )?.firstName ?? 'Customer'
        }}
      </h3>
      <h4>{{ (activeThread$ | async)?.thread?.orderCard?.label }}</h4>
    } @else {
      <h3>Chatting with Staff</h3>
      <h4>{{ (activeThread$ | async)?.thread?.orderCard?.label }}</h4>
    }
  </div>
  <div class="section" id="close-btn-section">
    <button mat-icon-button (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="messages" #messages>
  @for (message of (activeThread$ | async)?.messages; track $index) {
    <aa-chat-message
      [message]="message"
      [isStaffApp]="!!(isStaffApp$ | async)"
      [class.sender]="
        isSender(message, $any(currentUser$ | async), isStaffApp$ | async)
      "
      [showTime]="
        !!(
          getLastNonSenderMessage(
            (activeThread$ | async)?.messages ?? [],
            isStaffApp$ | async
          )?.id == message.id ||
          isTimeGap(message, (activeThread$ | async)?.messages?.at($index - 1))
        )
      "
      [showRead]="
        getLastReadSenderMessage(
          (activeThread$ | async)?.messages ?? [],
          isStaffApp$ | async
        )?.id == message.id
      "></aa-chat-message>
  }
</div>

<div class="controls">
  <input
    matInput
    placeholder="Type your message here.."
    [maxLength]="2000"
    [formControl]="messageFormControl"
    (keyup.enter)="sendMessage()" />
  <button mat-flat-button color="primary" (click)="sendMessage()">
    <mat-icon>send</mat-icon>
  </button>
</div>
